// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"252":"1ffb5ef2","421":"83571726","535":"4f3af8a7","904":"991d6644","983":"4f5a0db7"}[chunkId] + ".chunk.css";
};